import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/elements/button";
import { Dropdown, Menu } from "../../../components/Dropdown";
import { useLocation, useParams } from "react-router-dom";
import Icon from "../../../components/icons";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import toast from "react-hot-toast";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
import moment from "moment";
import Loader from "../../../components/loader";
import Drawer from "../../../components/Drawer";
import ScheduleModalWorkOrder from "./schedulepopupWorkOrder";
import InprogressModalWorkOrder from "./inprogresspopupWorkOrder";
import CancelModalWorkOrder from "./cancelpopupWorkOrder";
import CompleteIncompleteModalWorkOrder from "./completeincompletepopupWorkOrder";
import { getPermissionInfo } from "../../../_common/functions";
import { useUserSelector } from "../../../store/selectors/userSelector";

interface Props {
  workorder?: any;
}

const SidebarWOdetails: React.FC<Props> = ({ workorder }) => {
  const workOrderAPI: any = useWorkOrderApi();
  const workRequestAPI: any = useWorkRequestApi();
  const loggedinuser: any = useUserSelector();
  const location = useLocation();

  const params: any = useParams();

  const [statusList, setStatusList] = useState<any>([]);
  const [workrequest, setWorkrequest] = useState<any>(null);
  const [workrequestimage, setWorkrequestimages] = useState<any>(null);
  const [showloader, setShowloader] = useState<boolean>(false);
  const [currentStatus, setCurrentStatus] = useState<any>(null);
  const schedulerDrawerRef: any = useRef();
  const createSchedulerModalRef: any = useRef();
  const inprogressDrawerRef: any = useRef(null);
  const createInprogressModalRef: any = useRef();

  const cancelDrawerRef: any = useRef();
  const createCancelModalRef: any = useRef();
  const completeIncompleteDrawerRef: any = useRef();
  const createCompleteIncompleteModalRef: any = useRef();

  const [editData, setEditData] = useState<any>(null);
  const [isAssignonly, setIsAssignonly] = useState<boolean>(false);

  // Check if user has permission to Change Task Status
  const canChangeStatus = getPermissionInfo(location.pathname, "Change Task Status", loggedinuser);

  const GetStatusList = async () => {
    const wostatusdata: any = await new Promise((resolve, reject) => {
      workOrderAPI.GetWOStatusList(
        {},
        (resp: any) => resolve(resp),
        (error: any) => {
          toast.error(error);
          reject(error);
        }
      );
    }).catch((error: any) => { });
    if (wostatusdata && wostatusdata.hasOwnProperty(`workOrderStatusList`)) {
      console.log(`wostatusdata`, wostatusdata.workOrderStatusList);
      var statusset = [];
      if (workorder && workorder.hasOwnProperty(`woStatusID`)) {
        const statusMapArr: any = {
          0: [1, 2, 4, 5, 6, 3, 7],
          1: [7, 2, 3, 4],
          7: [2, 3],
          2: [4, 3],
          4: [5, 6, 3],
          5: [],
          6: [],
          3: []
        }
        if (statusMapArr[+workorder.woStatusID]) {
          statusset = wostatusdata.workOrderStatusList.filter((o: any) => statusMapArr[+workorder.woStatusID].includes(+o.woStatusID));
        }
      }
      console.log("Status List is > ", statusset);
      setStatusList(statusset);
    }
    if (workorder.workRequestID && +workorder.workRequestID > 0) {
      setShowloader(true);
      const wrapiresp: any = await Promise.all([
        new Promise((resolve, reject) => {
          workRequestAPI.GetWorkRequestByID(
            { WorkRequestID: workorder.workRequestID },
            (resp: any) => {
              if (resp.hasOwnProperty(`addedDate`) && resp.addedDate) {
                resp[`bind_addedDate`] = moment.utc(resp.addedDate).local().format("MM/DD/YY");
              }
              resolve(resp);
            },
            (error: any) => {
              //toast.error(error);
              reject(error);
            }
          );
        }),
        new Promise((resolve, reject) => {
          workRequestAPI.GetWorkRequestImages({ WorkRequestID: workorder.workRequestID }, (resp: any) => {
            if (resp && resp.files && Array.isArray(resp.files) && resp.files.length > 2) {
              resp.files = resp.files.slice(0, 3);
            }
            resolve(resp);
          }, (error: any) => {
            reject(error);
          });
        }),
      ]).catch((err: any) => { });
      if (wrapiresp && Array.isArray(wrapiresp) && wrapiresp.length > 0) {
        if (wrapiresp[0]) {
          setWorkrequest(wrapiresp[0]);
        }

        if (wrapiresp[1]) {
          setWorkrequestimages(wrapiresp[1]);
        }
      }
      setShowloader(false);
    }
  };

  const worOrderStatusChange = async (statusID: any) => {
    // Check permission before allowing status change
    if (!canChangeStatus) {
      toast.error("You don't have permission to change Task status");
      return;
    }

    console.log("statusID", statusID);
    setCurrentStatus(statusID);
    if (statusID === 2) {
      setIsAssignonly(false);
      schedulerDrawerRef?.current?.open();
    }
    if (statusID === 7) {
      setIsAssignonly(true);
      schedulerDrawerRef?.current?.open();
    }
    if (statusID === 3) {
      cancelDrawerRef?.current?.open();
    }
    if (statusID === 4) {
      // Previous code - opens popup form
      // inprogressDrawerRef?.current?.open();
      
      // New code - Directly call API without opening the popup
      const datetime = moment().utc().toISOString();
      const payload: any = {
        workOrderID: workorder.workOrderID,
        ProgressStatusNote: `Task started by ${loggedinuser?.firstName} ${loggedinuser?.lastName} at ${datetime}`,
        StartedBy: loggedinuser?.userID || null,
        WorkOrderStatusID: statusID,
        OriginalStartDate: datetime
      };

      if(!workorder?.workOrderUserMappingList){
        workOrderAPI.UpdateWorkOrderSchedule({
          "workOrderID": workorder.workOrderID,
          "workOrderStatusID": 4,
          "assignmentTypeID": loggedinuser?.userTypeID,
          "startDate": datetime,
          "endDate": moment().add(15, 'minutes').utc().toISOString(),
          "notes": "",
          "departmentID": null,
          "woGrowerID": null,
          "woVendorID": null,
          "woUserMapping": [
            {
              "userID": loggedinuser?.userID,
            }
          ]
        }, (resp: any) => {}, (error: any) => { });
      }
      
      setShowloader(true);
      try {
        await new Promise((resolve, reject) => {
          workOrderAPI.UpdateWorkOrderInprogress(payload, (resp: any) => {
            resolve(resp);
          }, (error: any) => {
            reject(error);
          });
        });
        // Hide loader first, then show success message
        setShowloader(false);
        toast.success("Task status updated successfully");
        // Wait a bit for user to see the message, then reload
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } catch (error) {
        setShowloader(false);
        toast.error("Failed to update task status");
      }
      return;
    }

    if (statusID === 5 || statusID === 6) {
      completeIncompleteDrawerRef?.current?.open();
    }
  };

  useEffect(() => {
    if (workorder) {
      GetStatusList();
    }
  }, []);

  return (
    <>
      {showloader && (
        <div 
          style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100vw', 
            height: '100vh', 
            backgroundColor: 'rgba(255, 255, 255, 0.8)', 
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Loader />
        </div>
      )}
      <div className="max-w-[17.125rem] m-auto sticky" style={{ top: `1.125rem` }}>
        <h4 className="font-semibold text-[0.938rem] pb-1" style={{ paddingLeft: `25px` }}>Status</h4>
      <div className={`flex items-center gap-2`}>
        <span style={{ width: `15px`, minWidth: `15px`, maxWidth: `15px`, height: `15px`, borderRadius: `15px`, backgroundColor: workorder?.woStatusHexCode || `#333` }}></span>
        <div>
          <Drawer _ref={schedulerDrawerRef} isAfterOpenRender={ true } onClose={() => {
            createSchedulerModalRef?.current?.reset();
            setEditData(null);
          }} 
          outsideClose={false}
          >
            <Drawer.Button></Drawer.Button>
            <Drawer.Content title={editData ? "Add Assigned" : "Add Assigned"} className="!w-[45rem]">
              {/*!w-[39.563rem]*/}
              <ScheduleModalWorkOrder
                _ref={createSchedulerModalRef}
                editData={workorder}
                currentStatus={currentStatus}
                isAssignonly={isAssignonly}
                onCreate={() => {
                  setEditData(null);

                  schedulerDrawerRef?.current?.close();
                  window.location.reload();
                }}
                onCancel={() => {
                  schedulerDrawerRef?.current?.close();
                }}
              />
            </Drawer.Content>
          </Drawer>

          <Drawer _ref={inprogressDrawerRef} onClose={() => {
            //createInprogressModalRef?.current?.reset();
            setEditData(null);
          }}
          outsideClose={false}
          >
            <Drawer.Button></Drawer.Button>
            <Drawer.Content title={ editData ? "Task Overview (" + workorder.workOrderCode + ")" : "Task Overview (" + workorder.workOrderCode + ")" } className="!w-[45rem]">
              {/*!w-[39.563rem]*/}
              <InprogressModalWorkOrder
                _ref={createInprogressModalRef}
                currentStatus={currentStatus}
                editData={workorder}
                onCreate={() => {
                  setEditData(null);
                  inprogressDrawerRef?.current?.close();
                  window.location.reload();
                }}
                onCancel={() => {
                  inprogressDrawerRef?.current?.close();
                }}
              />
            </Drawer.Content>
          </Drawer>

          <Drawer _ref={cancelDrawerRef} onClose={() => {
              createCancelModalRef?.current?.reset();
              setEditData(null);
            }}
            outsideClose={false}
          >
            <Drawer.Button></Drawer.Button>
            <Drawer.Content
              title={
                editData
                  ? "Task Overview (" + workorder.workOrderCode + ")"
                  : "Task Overview (" + workorder.workOrderCode + ")"
              }
              className="!w-[45rem]"
            >
              {/*!w-[39.563rem]*/}
              <CancelModalWorkOrder
                _ref={createCancelModalRef}
                currentStatus={currentStatus}
                editData={workorder}
                onCreate={() => {
                  setEditData(null);

                  cancelDrawerRef?.current?.close();
                  window.location.reload();
                }}
                onCancel={() => {
                  cancelDrawerRef?.current?.close();
                }}
              />
            </Drawer.Content>
          </Drawer>

          <Drawer _ref={completeIncompleteDrawerRef} isAfterOpenRender={ true } onClose={() => {
              createCompleteIncompleteModalRef?.current?.reset();
              setEditData(null);
            }}
            outsideClose={false}
          >
            <Drawer.Button></Drawer.Button>
            <Drawer.Content
              title={
                editData
                  ? "Task Overview (" + workorder.workOrderCode + ")"
                  : "Task Overview (" + workorder.workOrderCode + ")"
              }
              className="!w-[45rem]"
            >
              {/*!w-[39.563rem]*/}
              <CompleteIncompleteModalWorkOrder
                _ref={createCompleteIncompleteModalRef}
                editData={workorder}
                currentStatus={currentStatus}
                onCreate={() => {
                  setEditData(null);

                  completeIncompleteDrawerRef?.current?.close();
                  window.location.reload();
                }}
                onCancel={() => {
                  completeIncompleteDrawerRef?.current?.close();
                }}
              />
            </Drawer.Content>
          </Drawer>
          <Dropdown>
            <Dropdown.Button>
              <Button
                className={`${[3, 5, 6].includes(+workorder.woStatusID) || !canChangeStatus ? `pointer-events-none`: ``}`}
                customstyle={{
                  border: `1px solid #CECECE`,
                  width: `265px`,
                  height: `46px`,
                  padding: `14px 19px`,
                  borderRadius: `5px`,
                  background: !canChangeStatus ? `#f5f5f5` : `#fff`,
                  opacity: !canChangeStatus ? `0.6` : `1`,
                }}
                childstyle={{
                  display: `flex`,
                  justifyContent: `space-between`,
                  alignItems: `center`,
                }}
                disabled={!canChangeStatus || [3, 5, 6].includes(+workorder.woStatusID)}
              >
                <span
                  className="text-[0.938rem]"
                  style={{ color: workorder?.woStatusHexCode || `#333` }}
                >
                  {workorder?.woStatusName || `Unscheduled`}
                </span>
                {Array.isArray(statusList) && statusList.length > 0 && canChangeStatus && (
                  <Icon
                    name="chevrondown"
                    size={1.25}
                    className={``}
                    style={{}}
                  />
                )}
              </Button>
            </Dropdown.Button>
            <Dropdown.Content title="Status" className="!w-[265px]">
              {Array.isArray(statusList) && canChangeStatus && (
                <>
                  {statusList.map((status: any) => {
                    return (
                      <Menu onClick={() => worOrderStatusChange(status.woStatusID)} key={status.woStatusID}>
                        <div className={`text-[0.938rem]`} style={{ color: status.woStatusHexCode || `#333` }}>
                          {status.woStatusName}
                        </div>
                      </Menu>
                    );
                  })}
                </>
              )}
            </Dropdown.Content>
          </Dropdown>
        </div>
      </div>

      <h4 className="font-semibold text-[0.938rem] pt-4 border-b border-gray-200 pb-3">
        Assignee
      </h4>
      <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
        <div className="w-[12.5rem] text-[#767676]">
          <div className="mr-2">Assignment Type </div>
        </div>
        <div className="w-3/4 text-[#323233]">
          {workorder?.woAssignmentTypeName || `--`}
        </div>
      </div>
      {/* Previous role-specific labels kept for reference
      {workorder?.woAssignmentTypeID == 1 && (
        <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
          <div className="w-[12.5rem] text-[#767676]">
            <div className="mr-2">Technician Name</div>
          </div>
          <div className="w-3/4 text-[#323233]">
            <div style={{ display: `flex`, flexWrap: `wrap`, gap: `4px` }}>
              {workorder?.workOrderUserMappingList &&
                Array.isArray(workorder.workOrderUserMappingList) && (
                  <>
                    {workorder?.workOrderUserMappingList.map(
                      (user: any, index: number) => {
                        return (
                          <span
                            key={user.userID + `-` + index}
                            style={{
                              display: `block`,
                              lineHeight: `normal`,
                              background: `#f6f6f6`,
                              border: `1px solid #dadada`,
                              borderRadius: `5px`,
                              padding: `2px 6px`,
                              fontSize: `0.875rem`,
                            }}
                          >
                            {user.userName}
                          </span>
                        );
                      }
                    ) || `--`}
                  </>
                )}
            </div>
          </div>
        </div>
      )}
      {workorder?.woAssignmentTypeID == 2 && (
        <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
          <div className="w-[12.5rem] text-[#767676]">
            <div className="mr-2">Grower Name</div>
          </div>
          <div className="w-3/4 text-[#323233]">
            {workorder?.woGrowerName || ``}
          </div>
        </div>
      )}
      {workorder?.woAssignmentTypeID == 3 && (
        <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
          <div className="w-[12.5rem] text-[#767676]">
            <div className="mr-2">Vendor Name</div>
          </div>
          <div className="w-3/4 text-[#323233]">
            {workorder?.woVendorName || ``}
          </div>
        </div>
      )}
      */}
      <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
        <div className="w-[12.5rem] text-[#767676]">
          <div className="mr-2">Assigned User</div>
        </div>
        <div className="w-3/4 text-[#323233]">
          {Array.isArray(workorder?.workOrderUserMappingList) && workorder.workOrderUserMappingList.length > 0 ? (
            <div style={{ display: `flex`, flexWrap: `wrap`, gap: `4px` }}>
              {workorder.workOrderUserMappingList.map((user: any, index: number) => (
                <span
                  key={user.userID + `-` + index}
                  style={{
                    display: `block`,
                    lineHeight: `normal`,
                    background: `#f6f6f6`,
                    border: `1px solid #dadada`,
                    borderRadius: `5px`,
                    padding: `2px 6px`,
                    fontSize: `0.875rem`,
                  }}
                >
                  {user.userName}
                </span>
              ))}
            </div>
          ) : workorder?.woAssignmentTypeID === 2 ? (
            workorder?.woGrowerName || `--`
          ) : workorder?.woAssignmentTypeID === 3 ? (
            workorder?.woVendorName || `--`
          ) : (
            `--`
          )}
        </div>
      </div>
      <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
        <div className="w-[12.5rem] text-[#767676]">
          <div className="mr-2">Department</div>
        </div>
        <div className="w-3/4 text-[#323233]">
          {workorder?.departmentName || `--`}
        </div>
      </div>

      {workrequest && !showloader && (
        <div>
          <h4 className="font-semibold text-[0.938rem] pt-4 border-b border-gray-200 pb-3">Work Request</h4>
          <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
            <div className="w-[12.5rem] text-[#000000]">
              <div className="mr-2">
                <a href={`/work-request/${workrequest.workRequestID}`} target="_blank" className={`text-[#000000]`}>{workrequest?.workRequestCode || `--`}</a>
              </div>
            </div>
          </div>
          {/*
          <div className="py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
            <div className="w-[12.5rem] text-[#767676]"><div className="mr-2">Title</div></div>
            <div className="w-3/4 text-[#323233]">The pump in our building is not working.</div>
          </div>
          */}
          <div className="py-3 border-b border-gray-200 items-center flex flex-col text-[0.938rem]">
            <div className="w-full text-[#767676]">
              <div className="mr-2">Initial Description</div>
            </div>
            <div className="w-full text-[#323233] line-clamp-2 mt-1">
              {workrequest?.description || `--`}
            </div>
          </div>
          <div className="py-3 border-b border-gray-200 items-center flex flex-col text-[0.938rem]">
            <div className="w-full text-[#767676]">
              <div className="mr-2">Priority</div>
            </div>
            <div className="w-full text-[#323233] mt-1 line-clamp-1">
              {workrequest?.workRequestPriorityName || `--`}
            </div>
          </div>
          <div className="py-3 border-b border-gray-200 items-center flex flex-col text-[0.938rem]">
            <div className="w-full text-[#767676]">
              <div className="mr-2">Reported by</div>
            </div>
            <div className="w-full text-[#323233] mt-1 line-clamp-1">
              {workrequest?.addedByName || `--`} on{" "}{workrequest?.bind_addedDate}
            </div>
          </div>
          {workrequestimage && workrequestimage?.files && workrequestimage.files.length > 0 && (
            <div className="py-3 border-b border-gray-200 items-center flex flex-row text-[0.938rem]">
              <div className={`flex gap-2 flex-wrap`}>
                {workrequestimage.files.map((image: any, index: number) => (
                  <a key={index} href={image.fullFilePath} target="_blank" rel="noopener noreferrer" style={{ width: `86px`, height: `83px`, borderRadius: `5px`, overflow: `hidden` }}>
                    <img src={image.fullFilePath} alt={image.originalFileName} style={{ width: `100%`, height: `100%`, objectFit: `cover`, objectPosition: `center` }} />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div></div>
      </div>
    </>
  );
};

export default SidebarWOdetails;
